
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import apiService from "../service/apiService";

const PanComparisionComponent = ({ pan, setShowModal, otherDetails, setParentKycPan }) => {

  const [kycPan, setKycPan] = useState({});

  const [panDetailsModal, setPanDetailsModal] = useState(false);
  const getPanDetails = (pan) => {
    apiService.getKycPanList(pan).then((response) => {
      console.log("kycPan", kycPan);
      setParentKycPan(response.data && response.data.updatedTaxpayers ? response.data.updatedTaxpayers[0] : {})
      setKycPan(response.data && response.data.updatedTaxpayers ? response.data.updatedTaxpayers[0] : {});
      setPanDetailsModal(true);
    }).catch(r => {
      setParentKycPan({});
      setKycPan({});

    });
    console.log("inside get pan details>>", pan);
    console.log("panDetailsModal", panDetailsModal);
  }

  useEffect(() => {
    if (pan && !pan.includes('_'))
      getPanDetails(pan);
  }, [pan]);

  console.log("Current PAN Details:", kycPan);
  console.log("Other Details:", otherDetails);

  return (
    <Dialog
      header={("Pan Comparison Info")}
      visible={true}
      style={{ width: "50% ", height: "60%" }}
      onHide={() => setShowModal(false)}
    >

      <div >
        {<div>
          {/* {kycPan  ? kycPan.map((item, index)=>{ */}
          {/* return( */}
          <table style={{ border: 1, lineHeight: "1.5", padding: "10px", width: "100%" }} >

            <div style={{ margin: "20px", display: 'contents' }}
              className="compare-table UI-cards">
              <tr style={{ fontSize: "1.0em", fontWeight: "bold" }} >
                <th >KYC Details </th>
                {/* <td style={{paddingBottom: "10px"}} ></td> */}
                <td >Pan Details</td>
              </tr>
              <tr>
                <tr >
                  {otherDetails && otherDetails.length > 0 && otherDetails.map(o => {
                    return (
                      <tr>
                        <th >{o.title}</th>
                        <td >
                          {o.data}
                        </td>
                        {/* <td >
                                      {o.data1}
                                    </td>   */}
                      </tr>)
                  })}
                  {/* <th >Name</th>
                                    <td >
                                      {companyName}
                                    </td>    */}
                </tr>
                <td>
                  <tr style={{ padding: '5%', display: 'block' }}>
                    {kycPan.tradeNameEnglish}
                  </tr>
                  <tr style={{ padding: '5%', display: 'block' }}>
                    {kycPan.tradeNameNepali}
                  </tr>
                </td>
              </tr>
            </div>

          </table>
          {/* ) */}
          {/* }) : "No data"
                            } */}
        </div>
        }
      </div>
    </Dialog>
  );
};


export default PanComparisionComponent;
